import React from 'react';

import Component from './component';
import fixtures from './fixtures';
import transform from './transformer';

const BrokerReciprocityCard = (props) => <Component {...transform(props)} />;

export default BrokerReciprocityCard;

export { Component as component, fixtures, transform as transformer };
